module.exports = __webpack_public_path__ + "fonts/SFUIText-LightItalic.f342ffc8.ttf";